module.exports = __webpack_public_path__ + "static/media/whatIs.d39e925a.mp3";